import React from 'react';

const SimpleDataGrid = ({ children, className = '' }) => {
    const containerClasses = [
        'inline-grid',
        'grid-cols-[auto_auto]',
        'gap-x-16',
        'gap-y-2',
        'border',
        'border-gray-300',
        'rounded-lg',
        'px-8',
        'py-4',
        'bg-gray-50',
        className,
    ]
        .filter(Boolean)
        .join(' ');

    return <div className={containerClasses}>{children}</div>;
};

export default SimpleDataGrid;
